import React, { useState, useEffect } from "react";
import { culturalTables } from "../culturalTablesData";
import { motion, useAnimation } from "framer-motion";
import { playAudio, stopCurrentAudio } from "../utils/audioManager";

function TableSelection({ onSelect, onGoBack, culturalTableAudio }) {
  const [animatedDescriptions, setAnimatedDescriptions] = useState({});
  const controls = useAnimation();
  const publicUrl = process.env.PUBLIC_URL || "";

  const handleTableSelect = (table) => {
    if (culturalTableAudio) {
      stopCurrentAudio();
    }
    playAudio("/sound/Ingredients.MP3", 1);
    onSelect(table);
  };

  const handleGoBack = () => {
    if (culturalTableAudio) {
      stopCurrentAudio();
    }
    onGoBack();
  };

  useEffect(() => {
    controls.start("visible");
    return () => {
      stopCurrentAudio();
    };
  }, [controls, culturalTableAudio]);

  const typewriterVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.03,
      },
    },
  };

  const letterVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", damping: 12, stiffness: 200 },
    },
  };

  return (
    <div className="p-8 bg-gradient-to-br from-blue-100 to-purple-100 rounded-xl shadow-lg">
      <div className="flex flex-col items-center mb-8">
        <button
          onClick={handleGoBack}
          className="self-start bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-full focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
        >
          Go Back
        </button>
        <h2 className="text-4xl font-bold text-center text-blue-800">
          Choose a Cultural Table
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {culturalTables.map((table) => (
          <motion.button
            key={table.id}
            onClick={() => handleTableSelect(table)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
          >
            <img
              src={`${publicUrl}/images/tables/${table.imageUrl}`}
              alt={table.name}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="font-bold text-2xl mb-2 text-blue-700">
                {table.name}
              </h3>
              <motion.p
                className="text-sm text-gray-600 h-20 overflow-hidden"
                initial="hidden"
                animate={controls}
                variants={typewriterVariants}
              >
                {table.description.split("").map((char, index) => (
                  <motion.span key={index} variants={letterVariants}>
                    {char}
                  </motion.span>
                ))}
              </motion.p>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
}

export default TableSelection;
